import { Box, Button, useTheme, Select, MenuItem, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { alphabet, filterByLetter } from "../../srevices/ABC";
import styles from "./Alphabet.styles";

function Alphabet({ citiesList, setCurrentPage, setFilteredCities }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Проверяем, если устройство мобильное
  const [selectedLetter, setSelectedLetter] = useState(""); // Состояние для отслеживания выбранной буквы

  const handleFilter = (letter) => {
    setCurrentPage(1);
    setSelectedLetter(letter); // Устанавливаем выбранную букву
    filterByLetter(letter, citiesList, setFilteredCities);
  };

  const handleShowAll = () => {
    setFilteredCities(citiesList);
    setCurrentPage(1);
    setSelectedLetter(""); // Сброс выбранной буквы
  };

  return (
    <>
      <Box sx={styles.abcBox}>
        {isMobile ? (
          <Select
            fullWidth
            value={selectedLetter} // Устанавливаем выбранное значение
            onChange={(e) => handleFilter(e.target.value)}
            sx={styles.getNeonButton(theme)}
            displayEmpty
          >
            <MenuItem value="" disabled>Выберите первую букву города</MenuItem> {/* Плейсхолдер */}
            {alphabet.map((letter) => (
              <MenuItem key={letter} value={letter}>
                {letter.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        ) : (
          alphabet.map((letter) => (
            <Button
              key={letter}
              onClick={() => handleFilter(letter)}
              sx={styles.getNeonButton(theme)}
            >
              {letter.toUpperCase()}
            </Button>
          ))
        )}
      </Box>

      <Box sx={styles.btnAllCitiesBox}>
        <Button onClick={handleShowAll} sx={{ ...styles.getNeonButton(theme), marginBottom: "35px" }}>
          Все города
        </Button>
      </Box>
    </>
  );
}

export default Alphabet;
